import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

const PartnerBankAccountFormComponent = (props) => {

  const {t, partnerId} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const routeId = entity === 'partner-bank-account' ? id : null;
  const effectiveId = props.bankAccountId ?? routeId;
  const isEdit = !!effectiveId;

  const validate = (data) => {
    let errors = {};
    if (!data.iban && !formData.iban) {
      errors.iban = 'Kötelező mező';
    }
    return errors;
  };

  const formatIban = (raw = '') => {
    const cleaned = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    return cleaned.match(/.{1,4}/g)?.join(' ') ?? '';
  };

  const cleanIban = (value = '') =>
    value.toUpperCase().replace(/[^A-Z0-9]/g, '');

  const onSubmit = (data, form) => {
    setLoading(true);

    const ibanToSend = cleanIban(formData.iban || data.iban || newFormData.iban || '');
    const payload = {
        iban: ibanToSend,
        ...(partnerId ? { partner: partnerId } : {}),
    };

    if (isEdit) {
        apiCall('patch', '/api/v2/partner-bank-account/' + effectiveId, payload)
        .then(response => {
            window.App.toastShow('success', t('toastSaveSuccess'));
            window.App.setState({rerenderPartnerBankAccountList: Math.random()});
            if (props.goback === true && props.backlink) {
            history.push(props.backlink);
            }
        })
        .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
            setLoading(false);
        });
    } else {
        apiCall('post', '/api/v2/partner-bank-account', payload)
        .then(response => {
            window.App.toastShow('success', t('toastSaveSuccess'));
            window.App.setState({rerenderPartnerBankAccountList: Math.random()});
            if (props.goback === true && props.backlink) {
            history.push(props.backlink);
            } else {
            history.push('/partner-bank-account/update/' + response.data.data.id);
            }
        })
        .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
            setLoading(false);
        });
    }
  };


  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],
  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  useEffect(() => {
    if (isEdit) {
        setLoading(true);
        apiCall('get', '/api/v2/partner-bank-account/' + effectiveId)
        .then(response => {
            const data = response.data.data || {};
            const formattedIban = formatIban(data.iban || '');
            setFormData({
            ...data,
            iban: formattedIban,
            });
            setNewFormData({
            ...data,
            iban: formattedIban,
            });
        })
        .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
            setLoading(false);
        })
    }
  }, [isEdit, effectiveId, t]);

  return (
    <div className={"tmp-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="iban" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="iban"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIban')}</label>
                  <span className="p-d-block">
                      <InputText id="iban" {...input}
                                 onChange={(e) => {
                                   const formatted = formatIban(e.target.value);
                                   setFormData({
                                     ...formData,
                                     iban: formatted
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     iban: formatted
                                   })
                                 }}
                                 value={formData.iban || ''}
                                 placeholder={props.t('ibanExamplePlaceholder')}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'partner-bank-account' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(PartnerBankAccountFormComponent);
